import { FatInvestorsPageListFirmsQuery } from '@/__generated__/graphql';
import FormattingTooltip from '@/components/basicComponents/tooltip/dollarsTooltip';
import { TableColumns } from '@/components/table/types';
import styled from 'styled-components';

interface AdvisorTableSumFooterProps {
  columns: TableColumns[];
  totals: FatInvestorsPageListFirmsQuery['listFirms']['totals'];
}

const AdvisorTableSumFooter = ({ columns, totals }: AdvisorTableSumFooterProps) => {
  return (
    <TableSumWrap>
      <TableSumItem width={columns[0].width}>Total</TableSumItem>
      <TableSumItem width={columns[1].width}>{totals?.investorCount}</TableSumItem>
      <TableSumItem width={columns[2].width}>{totals?.investmentCount}</TableSumItem>
      <TableSumItem width={columns[3].width}>
        <FormattingTooltip>{totals?.totalValue}</FormattingTooltip>
      </TableSumItem>
      <TableSumItem width={columns[4].width}>
        <FormattingTooltip>{totals?.totalCommitments}</FormattingTooltip>
      </TableSumItem>
    </TableSumWrap>
  );
};

export default AdvisorTableSumFooter;

const TableSumWrap = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  min-height: 60px;
  background-color: ${({ theme }) => theme.layer[2]};
  border-radius: 8px;
  padding: 0 24px;
`;

const TableSumItem = styled.div<{ width: number; cursor?: string }>`
  display: flex;
  justify-content: flex-start;
  width: ${({ width }) => `${width}%`};
  color: ${({ theme }) => theme.font.base};
  font-family: Blinker, serif;
  font-size: 16px;
  font-weight: 600;
  line-height: 22px;
  letter-spacing: 0;
  cursor: ${({ cursor }) => cursor};
`;
